import React from 'react'
import Navbar from '../inc/Navbar'
import  about from "../images/about.png";

function Aboutus() {
  return (
    <div>
          <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
              <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-6 mt-0">
<h2>Aqua Dimon RO System –<b> About Us</b></h2>
<h5 className='justify'>Aqua Dimon RO System is a trusted water purification solutions provider dedicated to delivering pure, safe, and high-quality water through advanced RO and filtration technology. We offer reliable water treatment systems designed for residential, commercial, institutional, and industrial requirements.</h5>
<h6 className='nearairpotkolkata justify mb-2'>Our systems are built with quality components and modern purification technology to provide efficient performance, low maintenance, and long-lasting reliability. We understand that clean water is essential for a healthy life, which is why we focus on providing dependable solutions tailored to the specific needs of every customer.</h6>
<h6 className='justify'>From RO water purification systems and filtration solutions to installation, servicing, and maintenance, our team is committed to quality workmanship and customer satisfaction.</h6>
<h4><b>Why Choose Aqua Dimon RO System?</b></h4>
<p className='mb-1'> ✔ Advanced RO & Water Purification Technology</p>
<p className='mb-1'> ✔ High-Quality Filtration Systems
</p>
<p className='mb-1'> ✔ Low Maintenance & Long Service Life</p>
<p className='mb-1'>✔ Reliable & Efficient Performance</p>
<p className='mb-1'>✔ RProfessional Installation & Service</p>

<p>✔ Customized Water Treatment Solutions</p>

<h6>Aqua Dimon RO System – Pure Water. Better Life. </h6>



                </div>
                 <div className="col-md-6 mt-0">
             <img src={about} className="card-img-top" alt="about"/>

                </div>
                </div>
                </div>
            </div>
            <br/>

    </div>
  )
}

export default Aboutus